import { type RouteRecordRaw } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';

const ExampleOverview = (): unknown => {
    return import(/* webpackPrefetch: true */ './example-overview-page.vue');
};

const ExampleHub = (): unknown => {
    return import(/* webpackPrefetch: true */ './example-hub-page.vue');
};

export const exampleOverviewRoute: RouteRecordRaw = {
    ...ROUTE_DATA.EXAMPLE_OVERVIEW_PAGE,
    components: {
        main: ExampleOverview
    }
};

export const exampleHubRoute: RouteRecordRaw = {
    ...ROUTE_DATA.EXAMPLE_HUB_PAGE,
    components: {
        main: ExampleHub
    }
};
